module.exports = __webpack_public_path__ + "static/ChangeNow-8da8f34df288c0a81c2c30e872f37703.png";